import { createContext, useContext } from "react"
import { notification } from "antd"

interface NotificationContextType {
  success: (message: string, description?: string) => void
  error: (message: string, description?: string) => void
  info: (message: string, description?: string) => void
  warning: (message: string, description?: string) => void
}

const NotificationContext = createContext<NotificationContextType>({
  success: () => {},
  error: () => {},
  info: () => {},
  warning: () => {},
})

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const notify = (
    type: "success" | "error" | "info" | "warning",
    message: string,
    description?: string
  ) => {
    notification[type]({
      message,
      description,
      placement: "top",
    })
  }

  return (
    <NotificationContext.Provider
      value={{
        success: (message, description) =>
          notify("success", message, description),
        error: (message, description) => notify("error", message, description),
        info: (message, description) => notify("info", message, description),
        warning: (message, description) =>
          notify("warning", message, description),
      }}
    >
      {children}
    </NotificationContext.Provider>
  )
}

export const useNotification = () => useContext(NotificationContext)
